export function extractRedirectFromURL(url) {
  const urlParams = new URLSearchParams(url);
  const encodedRedirect = urlParams.get("redirect");
  const redirect = encodedRedirect
    ? decodeURIComponent(encodedRedirect)
    : null;
 
  if (redirect && redirect.startsWith('codedesign.ai/')) {
    // Extract everything after codedesign.ai/
    const pathAndParams = redirect.substring('codedesign.ai/'.length);
    return `https://codedesign.ai/${pathAndParams}`;
  }
 
  if (redirect && redirect.startsWith('cdsn.me/')) {
    // Extract everything after cdsn.me/
    const pathAndParams = redirect.substring('cdsn.me/'.length);
    return `https://cdsn.me/${pathAndParams}`;
  }
 
  return redirect;
}
 
export function extractParam(url, param) {
  const urlParams = new URLSearchParams(url);
  const value = urlParams.get(param);
  return value;
}